// extracted by mini-css-extract-plugin
module.exports = {"preview_area_container":"PreviewArea_preview_area_container__1sJn9","preview":"PreviewArea_preview__38snV"};